import React, { useContext } from 'react';

import { ReactComponent as CircleAdmiration } from '../../assets/icons/CircleAdmiration.svg';

import Context from '../../store/context';
import Button from '../Buttons/Button/Button';
import DeleteInvoiceCard from '../Cards/DeleteInvoiceCard/DeleteInvoiceCard';

import classes from './DeleteInvoice.module.scss';

const DeleteInvoice = ({ deleteClick, invoiceIdx, date, pendingValue, invoicesSelected, isAgreement, description }) => {
  const {
    modal: { hideModal }
  } = useContext(Context);
  const lastInvoice = invoicesSelected === 1;
  return (
    <div className={classes.content}>
      <CircleAdmiration className={classes.icon} />
      <span className='semibold-18'>¿Seguro quieres eliminar esta cuenta de cobro?</span>
      <DeleteInvoiceCard
        className={classes.card}
        description={description}
        date={date}
        pendingValue={pendingValue}
        isAgreement={isAgreement}
      />
      <span className={`${classes.color} medium-16`}>
        {lastInvoice
          ? 'Solo hay una cuenta de cobro, si la eliminas, saldrás del pago y el proceso se perderá.'
          : 'Esta acción es irreversible y el total a pagar se ajustará.'}
      </span>
      <div className={classes.buttons}>
        <Button custom='secondary' onClick={hideModal}>
          No, regresar
        </Button>
        <Button onClick={() => deleteClick(invoiceIdx, lastInvoice)}>Eliminar</Button>
      </div>
    </div>
  );
};

export default DeleteInvoice;
